import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

var _templateObject;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Zoom } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import ArrowUpward from './components/ArrowUpward';
import Button from './components/Button';
import { isServerSide, serverDocument } from '../../utils';
/**
 *
 * API:
 *
 * - [BackToTop API](https://components-extra.netlify.app/components/back-to-top)
 * - inherits [Fab API](https://material-ui.com/api/fab/)
 */

var BackToTop = function BackToTop(_a) {
  var forwardedRef = _a.forwardedRef,
      _a$keepHash = _a.keepHash,
      keepHash = _a$keepHash === void 0 ? false : _a$keepHash,
      rest = __rest(_a, ["forwardedRef", "keepHash"]);

  var _useTheme = useTheme(),
      backToTop = _useTheme.mixins.backToTop,
      transitions = _useTheme.transitions;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      display = _useState2[0],
      setDisplay = _useState2[1];

  var _ref = isServerSide() ? serverDocument : document,
      body = _ref.body,
      documentElement = _ref.documentElement;

  var transitionDuration = {
    enter: transitions.duration.enteringScreen,
    exit: transitions.duration.leavingScreen
  };
  useEffect(function () {
    var startHeight = backToTop.startHeight;

    var onScroll = function onScroll() {
      if (body.scrollTop > startHeight || documentElement.scrollTop > startHeight) {
        setDisplay(true);
      } else {
        setDisplay(false);
      }
    };

    document.addEventListener('scroll', onScroll);
    return function () {
      return document.removeEventListener('scroll', onScroll);
    };
  }, [body.scrollTop, documentElement.scrollTop, backToTop, keepHash]);

  var scrollToTop = function scrollToTop() {
    if (!keepHash && !isServerSide()) {
      history.replaceState({}, '', '#');
    }

    documentElement && documentElement.scrollIntoView({
      behavior: 'smooth'
    });
  };

  return React.createElement(Zoom, {
    in: display,
    timeout: transitionDuration,
    style: {
      transitionDelay: "".concat(display ? transitionDuration.exit : 0, "ms")
    }
  }, React.createElement(Button, Object.assign({
    "aria-label": "Back to top",
    "data-testid": "back-to-top-button",
    color: "primary",
    onClick: scrollToTop,
    ref: forwardedRef
  }, rest), React.createElement(ArrowUpward, null)));
};

BackToTop.displayName = 'BackToTop';
var BackToTopExtra = styled(forwardRef(function (props, ref) {
  return React.createElement(BackToTop, Object.assign({}, props, {
    forwardedRef: ref
  }));
}))(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export default BackToTopExtra;